import { RootPaths } from "@src/appV2/App/paths";

export const SUPPORT_PATH = "support";
export const SUPPORT_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SUPPORT_PATH}`;

export const GUIDED_SUPPORT_PATH = "guided";
export const GUIDED_SUPPORT_FULL_PATH = `${SUPPORT_FULL_PATH}/${GUIDED_SUPPORT_PATH}`;

export const SHIFT_DETAILS_PATH = "shift/:shiftId";
export const SHIFT_DETAILS_FULL_PATH = `${SUPPORT_FULL_PATH}/${SHIFT_DETAILS_PATH}`;

export const CANCELLED_SHIFT_DETAILS_PATH = "cancelled-shift/:shiftId";
export const CANCELLED_SHIFT_DETAILS_FULL_PATH = `${SUPPORT_FULL_PATH}/${CANCELLED_SHIFT_DETAILS_PATH}`;

const SHIFT_SEGMENT = "shift";
const CANCELLED_SHIFT_SEGMENT = "cancelled-shift";

/**
 * Generates the full path to the shift details page for interactive support.
 * Uses encodeURIComponent to safely handle special characters in shiftId.
 */
export function getShiftDetailsPath(shiftId: string): string {
  return `${SUPPORT_FULL_PATH}/${SHIFT_SEGMENT}/${encodeURIComponent(shiftId)}`;
}

/**
 * Generates the full path to the cancelled shift details page.
 * Uses encodeURIComponent to safely handle special characters in shiftId.
 */
export function getCancelledShiftDetailsPath(shiftId: string): string {
  return `${SUPPORT_FULL_PATH}/${CANCELLED_SHIFT_SEGMENT}/${encodeURIComponent(shiftId)}`;
}
